export const getHomeLandingPageState = state => state.homeLandingPage;
